<template>
  <v-container fluid pa-0 ma-0 class="test_red">
    <v-container
      v-if="!$store.getters.storeInfo.isOpenNow && !$store.getters.cartDetails"
      fluid
      :class="{ 'checkout-container': $vuetify.breakpoint.mdAndUp }"
      px-0
      py-0
      px-md-10
      py-md-3
    >
      <div class="container-home">
        <v-row
          v-if="$vuetify.breakpoint.mdAndUp"
          no-gutters
          justify="center"
          justify-lg="space-between"
        >
          <v-col cols="4" class="test_blue">
            <v-row v-if="!showInfo" no-gutters justify="start">
              <v-icon class="pr-3" v-text="'mdi-clock-outline'" />
              <v-card-subtitle class="pl-0" v-text="openToday" />
              <v-icon color="primary" class="pr-3" v-text="'mdi-information'" />
              <v-card-subtitle
                class="pl-0 p-color text-btn"
                @click="handleClick"
                v-text="$t('discovery.seeMoreInfo')"
              />
              <v-icon
                v-if="showOffer && $vuetify.breakpoint.mdAndUp"
                color="#E3780C"
                class="pr-3"
                v-text="'mdi-tag'"
              />
              <v-card-subtitle
                v-if="showOffer && $vuetify.breakpoint.mdAndUp"
                style="color: #e3780c"
                class="pl-0"
                v-text="message"
              />
            </v-row>
            <router-link v-if="showInfo" to="/">
              <v-img
                :src="$store.getters.appInfo.logo"
                height="50px"
                contain
                position="left"
                class="logo"
                style="image-rendering: optimizeSpeed"
                :title="$t('general.go_to_homepage')"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="primary gray" />
                  </v-row>
                </template>
              </v-img>
            </router-link>
          </v-col>
          <v-col
            cols="4"
            class="d-flex justify-center align-center test_yellow"
          >
            <span
              v-if="showInfo"
              class="modal-title-bar"
              v-text="$store.getters.storeInfo.storeName"
            />
            <div v-else>
              <span
                v-if="openToday"
                class="openTodayText"
                v-text="$t('general.open_today')"
              />
              <span class="modal-title-bar" v-text="openToday" />
            </div>
          </v-col>
          <v-col cols="auto" md="4" class="d-flex justify-md-end test_red">
            <v-fab-transition>
              <v-btn :height="50" color="primary" rounded elevation="0">
                <v-icon class="pr-3" v-text="'mdi-calendar-clock'" />
                <span
                  class="btn modal-name-details"
                  v-text="$t('general.only_schedule_orders')"
                />
              </v-btn>
            </v-fab-transition>
          </v-col>
        </v-row>

        <v-fab-transition v-else>
          <v-btn x-large color="primary" elevation="0" block class="btn">
            <v-icon class="pr-3" v-text="'mdi-calendar-clock'" />
            <span
              class="btn modal-name-details"
              v-text="$t('general.only_schedule_orders')"
            />
          </v-btn>
        </v-fab-transition>
      </div>
    </v-container>
    <v-container
      v-if="$store.getters.cartDetails"
      fluid
      :class="{ 'checkout-container': $vuetify.breakpoint.mdAndUp }"
      px-0
      py-0
      px-md-10
      py-md-3
    >
      <div class="container-home">
        <v-row
          v-if="$vuetify.breakpoint.mdAndUp"
          no-gutters
          justify="center"
          justify-lg="space-between"
        >
          <v-col cols="4" class="test_blue">
            <v-row v-if="!showInfo" no-gutters justify="start">
              <v-icon class="pr-3" v-text="'mdi-clock-outline'" />
              <v-card-subtitle class="pl-0" v-text="openToday" />
              <v-icon color="primary" class="pr-3" v-text="'mdi-information'" />
              <v-card-subtitle
                class="pl-0 p-color text-btn"
                @click="handleClick"
                v-text="$t('discovery.seeMoreInfo')"
              />
              <v-icon
                v-if="showOffer && $vuetify.breakpoint.mdAndUp"
                color="#E3780C"
                class="pr-3"
                v-text="'mdi-tag'"
              />
              <v-card-subtitle
                v-if="showOffer && $vuetify.breakpoint.mdAndUp"
                style="color: #e3780c"
                class="pl-0"
                v-text="message"
              />
            </v-row>
            <router-link v-if="showInfo" to="/">
              <v-img
                :src="$store.getters.appInfo.logo"
                height="50px"
                contain
                position="left"
                class="logo"
                style="image-rendering: optimizeSpeed"
                :title="$t('general.go_to_homepage')"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="primary gray" />
                  </v-row>
                </template>
              </v-img>
            </router-link>
          </v-col>
          <v-col
            cols="4"
            class="d-flex justify-center align-center test_yellow"
          >
            <span
              v-if="showInfo"
              class="modal-title-bar"
              v-text="$store.getters.storeInfo.storeName"
            />
          </v-col>
          <v-col cols="auto" md="4" class="d-flex justify-md-end test_red">
            <v-fab-transition>
              <v-btn
                v-if="$store.getters.guestSessionId"
                :height="50"
                color="primary"
                rounded
                elevation="0"
                @click="handleShowDrawer()"
              >
                <v-icon v-text="'mdi-cart-minus'" />
                <span
                  class="btn modal-name-details"
                  v-text="$t('general.shoppingCart')"
                />
                <span
                  class="btn modal-name-details pl-5"
                  v-text="
                    $appFormatters.formatMoney(
                      $store.getters.cartDetails.subTotal
                    )
                  "
                />
              </v-btn>
            </v-fab-transition>
          </v-col>
        </v-row>

        <v-fab-transition v-else>
          <v-container>
            <v-btn
              x-large
              color="primary"
              elevation="0"
              block
              class="btn"
              @click="handleShowDrawer()"
            >
              <v-icon v-text="'mdi-cart-minus'" />
              <span
                class="btn-checkout-text pr-10"
                v-text="$t('general.shoppingCart')"
              />
              <span
                class="btn-checkout-total"
                v-text="
                  $appFormatters.formatMoney(
                    $store.getters.cartDetails.subTotal
                  )
                "
              />
            </v-btn>
          </v-container>
        </v-fab-transition>
      </div>
    </v-container>
    <v-dialog
      v-model="showInfoModal"
      persistent
      max-width="550"
      :fullscreen="$vuetify.breakpoint.mobile"
      transition="dialog-bottom-transition"
      :content-class="$vuetify.breakpoint.mobile ? '' : 'dialog-rounded'"
      :scrollable="false"
    >
      <StoreInfoDetail v-if="showInfoModal" v-model="showInfoModal" />
    </v-dialog>
    <v-bottom-sheet
      v-if="$vuetify.breakpoint.mdAndDown"
      v-model="showCheckoutDrawer"
    >
      <v-row
        style="
          display: flex;
          justify-content: flex-end;
          background-color: white;
          margin: 0;
          padding: 5px;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
        "
      >
        <v-btn
          icon
          x-large
          style="background-color: #f1f1f1"
          @click="hideDrawer()"
        >
          <v-icon x-large color="primary" v-text="'mdi-close'" />
        </v-btn>
      </v-row>
      <div style="background-color: white; max-height: 700px; overflow-y: auto">
        <CartDrawer @close="showCheckoutDrawer = false" />
      </div>
    </v-bottom-sheet>
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.lgAndUp"
      v-model="showCheckoutDrawer"
      style="border-top-left-radius: 20px; border-bottom-left-radius: 20px"
      app
      right
      fixed
      temporary
      :width="width"
    >
      <template>
        <v-row style="display: flex; justify-content: flex-end; padding: 20px">
          <v-btn icon style="background-color: #f1f1f1" @click="hideDrawer()">
            <v-icon x-large v-text="'mdi-close'" />
          </v-btn>
        </v-row>
      </template>
      <CartDrawer @close="showCheckoutDrawer = false" />
    </v-navigation-drawer>
  </v-container>
</template>

<script>
/*
Actions:
  Cartdetails is loaded in Public
*/
import moment from "moment-timezone";
import {
  StoreInfoDetail,
  CartDrawer,
} from "@/views/front/discovery/components/index";
export default {
  name: "CheckoutBar",
  components: {
    StoreInfoDetail,
    CartDrawer,
  },
  props: {
    showInfo: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showInfoModal: false,
    showCheckoutDrawer: false,
    today: new Date().toISOString().substr(0, 10),
    week: [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ],
  }),
  computed: {
    width: function () {
      switch (true) {
        case this.$vuetify.breakpoint.xsOnly:
          return "100%";
        case this.$vuetify.breakpoint.smOnly:
          return "60%";
        case this.$vuetify.breakpoint.mdOnly:
          return "50%";
        case this.$vuetify.breakpoint.lgAndUp:
          return "37%";
        default:
          return "100%";
      }
    },
    showOffer: {
      get() {
        if (this.$store.getters.storeInfo.hasOffers !== false) {
          return !this.$store.getters.storeInfo.hasOffers.isCodeRequired;
        } else {
          return false;
        }
      },
      set(val) {
        return val;
      },
    },
    message: {
      get() {
        return this.$t("offers.offer_text", {
          amount:
            this.$store.getters.storeInfo.hasOffers.type === "Amount"
              ? this.$appFormatters.formatMoney(
                  this.$store.getters.storeInfo.hasOffers.amount
                )
              : this.$store.getters.storeInfo.hasOffers.amount + "%",
        });
      },
      set(val) {
        return val;
      },
    },
    openToday: function () {
      let schedule = this.$store.getters.storeInfo.openingHours;
      let found = _.find(schedule, {
        dayName: this.week[moment(new Date(this.today)).add(0, "d").day()],
      });
      if (found.isClosed) {
        return this.$t("general.closed");
      } else {
        return (
          this.$appFormatters.formatTime24(found.open) +
          "-" +
          this.$appFormatters.formatTime24(found.closing)
        );
      }
    },
  },
  methods: {
    handleClick() {
      this.showInfoModal = true;
      // Call any function or perform any action you want here
    },
    handleShowDrawer() {
      this.showCheckoutDrawer = true;
      // Call any function or perform any action you want here
    },
    hideDrawer() {
      this.showCheckoutDrawer = false;
      // Call any function or perform any action you want here
    },
  },
};
</script>
<style lang="scss">
.overlay {
  position: relative;
}

.overlay:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    255,
    255,
    255,
    0.5
  ); /* Adjust the transparency by modifying the last value (0.5) */
  //z-index: 1;
}
.fs-mobile-dialog .v-dialog--fullscreen {
  top: 130px !important;
}
.checkout-container {
  border-bottom: solid !important;
  border-width: 1px !important;
  border-color: rgba($color: #afafaf, $alpha: 0.5) !important;
}

.openTodayText {
  font-size: 1.8rem;
}
.container-home {
  max-width: 1400px !important;
  margin: 0 auto;
}

@media screen and (max-width: 960px) {
  .container-home {
    max-width: none !important;
    //padding: 0 30px !important;
  }
}
</style>
